import { render, staticRenderFns } from "./ViewPoints.vue?vue&type=template&id=6577ac86&scoped=true"
import script from "./ViewPoints.vue?vue&type=script&lang=js"
export * from "./ViewPoints.vue?vue&type=script&lang=js"
import style0 from "./ViewPoints.vue?vue&type=style&index=0&id=6577ac86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577ac86",
  null
  
)

export default component.exports